<div *ngIf="validSearchConfigPath">
    <br>
    <h2>{{interfaceSearchHeader | hisUpperCaseFirstLetter }}</h2>
    <br>
    <div class="infoMessage" [innerHTML]="interfaceHelpText"></div>
    <br>
    <his-search-form
        #searchForm
        [configFile]="selectedInterfaceType.searchConfigurationPath"
        [isSearchFormResult]="true"
        [isNestedSearchForm]="true"
        [searchShowSearchParamsBox]="true"
        [showSearchButton]="false"
        [showLinkToSearchHelp]="false"
        [presetInputFields]="hasImportPublicationRight ? {} : { 'IGNORE:onlyMyPublications': '1' }"
        (onSubmitSearch)="executeImport($event)"
        [callerId]="callerId">
    </his-search-form>
    <div class="clearer"></div>
    <br>
    <button (click)="searchForm.submitSearchForm()" hisImage="LINE_OUT" class="transparent"><span>{{'fs.res.publication.import.start' | hisUi}}</span></button>
</div>

